
export const FRONT = 0;
export const RIGHT = 1;
export const REAR = 2;
export const LEFT = 3;
export const DONE = 4;

export const next = (val) => {
  switch (val) {
    case FRONT: return RIGHT;
    case RIGHT: return REAR;
    case REAR: return LEFT;
    default: return DONE;
  }
}